export const path = "M19 13H5v-2h14v2z";